import { Fragment } from "react";
import Editor from "../../../form/Editor";
import Input from "../../../form/Input";
import FileUploadSingle from "../../../form/FileUploadSingle";

export const VepetersPageForm = ({
  values,
  handleChange,
  errors,
  formValidate,
}) => {
  const maxLength = 20;
  return (
    <Fragment>
      <div className="my-4">
        <h4 className="font-semibold text-lg mb-2">Sub Section</h4>
        <div className="grid grid-cols-12 gap-4">
          {/* <div className="relative col-span-12">
            <FileUploadSingle
              label={"Upload Sub Section Image"}
              labelClasses={"!mb-2"}
              value={values?.subSectionimage}
              onChange={(file) =>
                handleChange({
                  target: { name: "subSectionimage", value: file },
                })
              }
              {...formValidate(errors, "subSectionimage")}
            />
          </div> */}
          <div className="relative col-span-3">
            <Input
              label="Title"
              inputPlaceholder="Enter Title"
              inputName="firstSubSectionTitle"
              value={values?.firstSubSectionTitle || ""}
              onChange={handleChange}
              {...formValidate(errors, "firstSubSectionTitle")}
            />
          </div>
          <div className="relative col-span-3">
            <Input
              label="Count"
              inputPlaceholder="Enter Count"
              inputName="firstSubSectionCount"
              value={values?.firstSubSectionCount || ""}
              maxLength={maxLength}
              onChange={handleChange}
              {...formValidate(errors, "firstSubSectionCount")}
            />
            <div className="text-xs mt-1">
              {maxLength - (values?.firstSubSectionCount?.length || 0)}{" "}
              characters remaining
            </div>
          </div>
          <div className="relative col-span-3">
            <Input
              label="Title"
              inputPlaceholder="Enter Title"
              inputName="secondSubSectionTitle"
              value={values?.secondSubSectionTitle || ""}
              onChange={handleChange}
              {...formValidate(errors, "secondSubSectionTitle")}
            />
          </div>
          <div className="relative col-span-3">
            <Input
              label="Count"
              inputPlaceholder="Enter Count"
              inputName="secondSubSectionCount"
              value={values?.secondSubSectionCount || ""}
              maxLength={maxLength}
              onChange={handleChange}
              {...formValidate(errors, "secondSubSectionCount")}
            />
            <div className="text-xs mt-1">
              {maxLength - (values?.secondSubSectionCount?.length || 0)}{" "}
              characters remaining
            </div>
          </div>
          <div className="relative col-span-3">
            <Input
              label="Title"
              inputPlaceholder="Enter Title"
              inputName="thirdSubSectionTitle"
              value={values?.thirdSubSectionTitle || ""}
              onChange={handleChange}
              {...formValidate(errors, "thirdSubSectionTitle")}
            />
          </div>
          <div className="relative col-span-3">
            <Input
              label="Count"
              inputPlaceholder="Enter Count"
              inputName="thirdSubSectionCount"
              value={values?.thirdSubSectionCount || ""}
              maxLength={maxLength}
              onChange={handleChange}
              {...formValidate(errors, "thirdSubSectionCount")}
            />
            <div className="text-xs mt-1">
              {maxLength - (values?.thirdSubSectionCount?.length || 0)}{" "}
              characters remaining
            </div>
          </div>
          <div className="col-span-3">
            <FileUploadSingle
              label={"Upload Sub Section Image"}
              labelClasses={"!mb-2"}
              size="small"
              value={values?.subSectionimage}
              onChange={(file) =>
                handleChange({
                  target: { name: "subSectionimage", value: file },
                })
              }
              {...formValidate(errors, "subSectionimage")}
            />
          </div>
        </div>
      </div>

      <div className="my-4">
        <h4 className="font-semibold text-lg mb-2">Inspire Section</h4>
        <div className="grid grid-cols-12 gap-4">
          <div className="relative col-span-6 space-y-4">
            <Input
              label="Title"
              inputPlaceholder="Enter Title"
              inputName="inspireTitle"
              value={values?.inspireTitle || ""}
              onChange={handleChange}
              {...formValidate(errors, "inspireTitle")}
            />
            <FileUploadSingle
              value={values?.inspireImage}
              onChange={(file) =>
                handleChange({
                  target: {
                    name: "inspireImage",
                    value: file,
                  },
                })
              }
              {...formValidate(errors, "inspireImage")}
            />
          </div>
          <div className="relative col-span-6">
            <Editor
              label="Description"
              placeholder="Enter Description"
              value={values?.inspireDesc}
              onChange={(val) =>
                handleChange({
                  target: { name: "inspireDesc", value: val },
                })
              }
              {...formValidate(errors, "inspireDesc")}
            />
          </div>
        </div>
      </div>

      <div className="my-4">
        <h4 className="font-semibold text-lg mb-2">Impact Section</h4>
        <div className="grid grid-cols-12 gap-4">
          <div className="relative col-span-6 space-y-4">
            <Input
              label="Title"
              inputPlaceholder="Enter Title"
              inputName="impactTitle"
              value={values?.impactTitle || ""}
              onChange={handleChange}
              {...formValidate(errors, "impactTitle")}
            />
            <FileUploadSingle
              value={values?.impactImage}
              onChange={(file) =>
                handleChange({
                  target: {
                    name: "impactImage",
                    value: file,
                  },
                })
              }
              {...formValidate(errors, "impactImage")}
            />
          </div>
          <div className="relative col-span-6">
            <Editor
              label="Description"
              placeholder="Enter Description"
              value={values?.impactDesc}
              onChange={(val) =>
                handleChange({
                  target: { name: "impactDesc", value: val },
                })
              }
              {...formValidate(errors, "impactDesc")}
            />
          </div>
        </div>
      </div>

      <div className="my-4">
        <h4 className="font-semibold text-lg mb-2">Publication Section</h4>
        <div className="grid grid-cols-12 gap-4">
          <div className="relative col-span-6 space-y-4">
            <Input
              label="Publication Title"
              inputPlaceholder="Enter Publication Title"
              inputName="publicationTitle"
              value={values?.publicationTitle || ""}
              onChange={handleChange}
              {...formValidate(errors, "publicationTitle")}
            />
          </div>
          <div className="relative col-span-6">
            <Editor
              label="Publication Description"
              placeholder="Enter Publication Description"
              value={values?.publicationDesc}
              onChange={(val) =>
                handleChange({
                  target: { name: "publicationDesc", value: val },
                })
              }
              {...formValidate(errors, "publicationDesc")}
            />
          </div>
        </div>
      </div>
    </Fragment>
  );
};
